import React, { memo } from 'react';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { useHideMobileApp } from 'common/hooks/use-hide-mobile-app';
import { FooterList } from '../footer-list';
import { selectCurrentRegion } from 'selectors';
import { ModelJsonStore } from '../../reducers';
import { FooterAppBlock, FooterAppBlockDesktop } from '../footer-app-block';
import { FooterSocialLinks } from '../footer-social-links/footer-social-links';
import { footer, FooterLayout, UpperFooter, socialLinks } from './styles';

export const Footer: React.FC = memo(() => {
  const { model } = useStoreon<ModelJsonStore>('model');
  const isHideMobileApp = useHideMobileApp();

  const currentRegion = selectCurrentRegion(model?.regions, model?.properties?.regionId);

  if (!model?.footer || !currentRegion) return null;

  return (
    <div data-qa="footer-content">
      {!isHideMobileApp && <FooterAppBlock />}
      <FooterLayout>
        <Layout className={footer}>
          <UpperFooter>
            <FooterList menuItems={model} />
            {!isHideMobileApp && <FooterAppBlockDesktop />}
          </UpperFooter>
          <FooterSocialLinks className={socialLinks} links={model.socialMedia} />
        </Layout>
      </FooterLayout>
    </div>
  );
});
